export default __webpack_public_path__ + "static/media/girlLaptopFlower.f73e0498.svg";